﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONFIG } from '../../../core/config';
import { LanguageService } from '../../../core/language/language.service';
import { DropdownItem } from '../../../core/models/dropdown-item';
import { SurveyDetails } from '../../../core/models/surveys/survey-details';
import { SecurityService } from '../../../core/services/security.service';
import { ToastService } from '../../../core/toast/toast.service';
import { SharedService } from '../../../shared/shared.service';
import { SurveysService } from '../../surveys.service';
@Component({
    selector: 'phone-verification',
    templateUrl: './phone-verification.component.html',
    styleUrls: ['./phone-verification.component.css']
})
export class PhoneVerificationComponent implements OnInit {
    public survey: SurveyDetails;
    private languageID: number;
    public pathname: string;
    public telNum: string = "";
    public confCode: string = "";
    public sendCodeIndicator: boolean = false;
    public haveCode: boolean = true;
    public organizations: DropdownItem[] = [];
    public link = '';

    timeLeft: number = 120;
    minutes: number = 2;
    seconds: number = 0;
    buttonDisabled: boolean = false;
    interval: any;
    //public icons: IconsModel[] = [];

    constructor(private _surveysService: SurveysService,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _languageService: LanguageService,
        private _route: ActivatedRoute, private _router: Router,
        private _toastService: ToastService) {
        this.survey = new SurveyDetails();
        this.languageID = this._languageService.selectedLanguageId;
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.pathname = this.pathname.replace('/fill-survey', '');
        this.pathname = this.pathname.substring(0, this.pathname.indexOf("phone-verification") + "phone-verification".length);
        this._route.params.subscribe(params => {
            let id = params['id'];
            if (id != null) {
                this.getSurveyByID(id);
            } else {
                this.initSurvey();
            }
        });
        this._securityService.currentUser.subscribe(result => {
            this.telNum = result ? result.telephoneNumber.replace(/^(\+|00)387/, "") : "";            
        });
    }

    initSurvey() {
    }
    
    haveCodeToggler(toggleToPhoneInputOnly: boolean) {
        if (toggleToPhoneInputOnly) {
            if (this.haveCode) {

                this.haveCode = !this.haveCode;
            }
        } else {
            this.haveCode = !this.haveCode;
        }
    }

    getSurveyByID(id: number) {
        this._surveysService.getSurveyBySurveyID(id, this.languageID).subscribe(result => {
            this.survey = result;
            this.link = this.survey.surveyTypeId == CONFIG.surveyTypeEnum.lokalna ? '/survey/fill-survey/survey-details' : '/survey/fill-survey/participant-details';
        });
    }

    save() {
        if (!this.validateCode()) {
            return;
        }
        this._surveysService.checkCode(this.telNum, this.survey.id, this.confCode).subscribe(result => {
            if (result > 0) {
                this._surveysService.saveSurveyParticipantID(result.toString());
                if (this.survey.surveyTypeId == CONFIG.surveyTypeEnum.lokalna) {
                    this._router.navigate([this.link, this.survey.surveyUniqueIdentifier, 1]);
                } else {
                    this._router.navigate([this.link, this.survey.surveyUniqueIdentifier]);
                }
            } else {
                this._toastService.activate(this._languageService.translate('uneseni_kod_pogresan'), "alert-danger");
            }
        });
    }

    get phonePattern() {
        return /^6\d{7,8}$/;
    }
    get onlyNumbersPattern() {
        return /^[0-9]*$/;
    }

    validatePhone() {
        if (this.telNum == "" || this.telNum == null ||
            !this.phonePattern.test(this.telNum))
            return false;
        else
            return true;
    }
    validateCode() {
        if (this.confCode == "" || this.confCode == null ||
            this.confCode.length != 5 ||
            !this.onlyNumbersPattern.test(this.confCode))
            return false;
        else
            return true;
    }

    sendCode() {
        this.sendCodeIndicator = true
        if (!this.validatePhone()) {
            return;
        }
        this.startTimer();
        this._surveysService.sendCode('+387'+this.telNum, this.survey.id, this.survey.masterSurveyId).subscribe(result => {
            if (result.success && result.result) {
                let msg = "verifikacioni_kod_poslat_SMS";
                msg = this._languageService.translate(msg);
                this._toastService.activate(msg, "alert-success");
                this.haveCodeToggler(false);

            } else {
                let msg = "verifikacioni_kod_nije_poslat_SMS";
                msg = this._languageService.translate(msg);
                this._toastService.activate(msg, "alert-danger");
                console.log(result.errors);
               
            }
        });
    }

    startTimer() {
        this.buttonDisabled = true;

        this.interval = setInterval(() => {
            this.timeLeft--;
            this.minutes = Math.floor(this.timeLeft / 60);
            this.seconds = this.timeLeft % 60;
            if (this.timeLeft == 0) {
                clearInterval(this.interval);
                this.timeLeft = 120;
                this.buttonDisabled = false;
            }
        }, 1000);
    }

}
